// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
export type DraftTaskDrawer_PlanTaskFragment = { __typename?: 'PlanTask', id: string, name: string, startDate: Types.Scalars['Date']['input'], endDate: Types.Scalars['Date']['input'], status: { __typename?: 'TaskStatusDetail', code: Types.TaskStatus, name: string }, tradePartner?: { __typename?: 'TradePartner', id: string, name: string } | null | undefined, tradePartnerStatus: { __typename?: 'TradePartnerTaskStatusDetail', code: Types.TradePartnerTaskStatus, name: string }, internalUser?: { __typename?: 'InternalUser', id: string, name: string } | null | undefined };

export const DraftTaskDrawer_PlanTaskFragmentDoc = gql`
    fragment DraftTaskDrawer_PlanTask on PlanTask {
  id
  name
  startDate
  endDate
  status {
    code
    name
  }
  tradePartner {
    id
    name
  }
  tradePartnerStatus {
    code
    name
  }
  internalUser {
    id
    name
  }
}
    `;